<!-- =========================================================================================
	File Name: ItemGridView.vue
	Description: Item Component - Grid VIew
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <!-- <div class="item-grid-view vx-row match-height">
        <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
    <vx-card
        class="grid-view-item mb-base overflow-hidden card-hover"
        style="-webkit-box-shadow: 0 4px 25px 0 rgba(0, 0, 0, .1);box-shadow: 0 4px 25px 0 rgba(0, 0, 0, .1);"
    >
        <template slot="no-body">
            <router-link :to="getItem(item)" style="width: 100%;height: 100%;">
                <!-- ITEM IMAGE -->
                <div class="item-img-container bg-white h-64 flex items-center justify-center mb-4">
                    <img :src="item.image" :alt="item.name" class="grid-view-img px-4">
                </div>
                <div class="item-details px-4">

                    <!-- RATING & PRICE -->
                    <div class="flex justify-between items-center">
                        <h6 class="font-bold ml-auto"><span class="text-xl">{{ item.point }}</span> {{ $t('points') }}</h6>
                    </div>

                    <!-- TITLE & DESCRIPTION -->
                    <div class="my-4">
                        <h6 class="truncate font-semibold mb-1">{{ item.title }}</h6>
                        <p class="item-description truncate text-sm">{{ item.description.replace(/<\/?[^>]+(>|$)/g, "") }}</p>
                    </div>
                </div>
                <!-- SLOT: ACTION BUTTONS -->
                <slot name="action-buttons"/>
            </router-link>
        </template>
    </vx-card>
    <!--  </div>
  </div> -->
</template>

<script>
    export default {
        props: {
            eventId: 0,
            item: {
                type: Object,
                required: true
            },
        },
        methods: {
            getItem(item) {
                return `/pages/events/${this.eventId}/prize/${item.id}`
            }
        }
    }
</script>

<style lang="scss" scoped>
    .grid-view-item {
        .grid-view-img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            transition: .35s;
        }

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

            .grid-view-img {
                opacity: 0.9;
            }
        }
    }

    .card-hover:hover {
        -webkit-transform: translateY(-5px) !important;
        -moz-transform: translateY(-5px) !important;
        -ms-transform: translateY(-5px) !important;
        -o-transform: translateY(-5px) !important;
        transform: translateY(-5px) !important;
        -webkit-box-shadow: 0 4px 25px 0 rgba(0, 0, 0, .25) !important;
        box-shadow: 0 4px 25px 0 rgba(0, 0, 0, .25) !important;
    }
</style>
